export const BRIDGE_STRAINS = ['C', 'D', 'H', 'S', 'NT'];
export function bridgeTrump(strain) {
    return strain === 'NT' ? null : strain;
}
//# sourceMappingURL=types.js.map